import { useLayoutEffect } from 'react';
import { useLocation } from 'wouter';

import {
  destinoDoCheckout,
  lerCarrinhoAtendimento,
} from '@/modules/atendimento/utils/carrinho-atendimento';
import { useGetMerchantDetails } from '@/modules/stores/hooks/http/use-get-merchant-details';
import { checkoutSlugFor, isShowcaseOnly } from './showcase';

function readStoredSlug(): string | null {
  try {
    return sessionStorage.getItem('store-slug');
  } catch {
    return null;
  }
}

// Sacola ou checkout aberto por link, histórico ou sacola antiga de uma loja que
// virou vitrine volta para a página da loja (a API recusa o pedido de qualquer
// jeito). Montado fora das rotas; não desenha nada.
export function ShowcaseCheckoutGuard() {
  const [location, navigate] = useLocation();
  // Sacola do atendimento (balcão/QR) tem destino próprio (PRAT-64) e não é vitrine.
  const fromAtendimento = destinoDoCheckout(location.split('?')[0], lerCarrinhoAtendimento());
  const slug = fromAtendimento ? null : checkoutSlugFor(location, readStoredSlug());
  const details = useGetMerchantDetails({ slug: slug ?? '' });

  useLayoutEffect(() => {
    if (slug && isShowcaseOnly(details.data)) navigate(`/${slug}`, { replace: true });
  }, [slug, details.data, navigate]);

  return null;
}
